module.exports = __webpack_public_path__ + "static/frontUserNew/img/typefolder.9d9b76e5.svg";